import { render, staticRenderFns } from "./UserVisitorForm.vue?vue&type=template&id=97194d22&scoped=true"
import script from "./UserVisitorForm.vue?vue&type=script&lang=js"
export * from "./UserVisitorForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97194d22",
  null
  
)

export default component.exports